export const LOAD_FRESHDESK_TOKEN = 'LOAD_FRESHDESK_TOKEN'
export const LOADING_FRESHDESK_TOKEN = 'LOADING_FRESHDESK_TOKEN'
export const LOAD_FRESHDESK_TOKEN_SUCCEEDED = 'LOAD_FRESHDESK_TOKEN_SUCCEEDED'
export const LOAD_FRESHDESK_TOKEN_FAILED = 'LOAD_FRESHDESK_TOKEN_FAILED'


export function loadFreshdeskToken() {
    return { type: LOAD_FRESHDESK_TOKEN }
}
